import * as React from 'react';
import { AmountsOptions, Recipe } from '@src/firebase/types';
import { ViewDivider } from '@src/routes/recipes/components/ViewDivider';
import { ViewStepIngredient } from '../ViewStepIngredient/ViewStepIngredient';

interface ViewIngredientsProps {
  className?: string;
  recipe: Recipe;
}

/**
 * @name ViewIngredients
 * @description tbd...
 */
const ViewIngredients: React.FC<ViewIngredientsProps> = (props) => {
  const { className, recipe } = props;

  // Setup
  const numIngredients = `${recipe.ingredients.length} Ingredients`;

  return (
    <div className={className}>
      <ViewDivider title={numIngredients} />
      <div>
        {recipe.ingredients.map((ingredient, index) => {
          const amount = AmountsOptions[ingredient.amount];

          return (
            <ViewStepIngredient
              key={index}
              amount={amount}
              ingredient={ingredient.name}
            />
          );
        })}
      </div>
    </div>
  );
};

export { ViewIngredients };
export type { ViewIngredientsProps };
